import { MapPin } from "lucide-react";

/** One-tap fill from the passenger's saved addresses. */
export const SavedPlaceChips = ({ places = [], onPick, testId }) => {
  if (!places.length) return null;
  return (
    <div data-testid={testId} className="-mt-1 flex flex-wrap gap-2">
      {places.map((p) => (
        <button
          type="button"
          key={p.id}
          data-testid={`${testId}-${p.label}`}
          onClick={() => onPick({
            address: p.address,
            formatted_address: p.formatted_address || p.address,
            place_id: p.place_id || null,
            lat: p.lat ?? null,
            lng: p.lng ?? null,
          })}
          className="flex items-center gap-1.5 rounded-full border border-ink-600 px-3 py-1 text-xs text-slate-400 transition-colors hover:border-gold/40 hover:text-gold"
        >
          <MapPin className="h-3 w-3 text-gold" /> {p.label}
        </button>
      ))}
    </div>
  );
};
